// action - state management
// types
import { AuthActionProps, AuthProps } from '~/types/auth';

import { INITIALIZED, LOGIN, LOGOUT, REGISTER, REQUIRES_2FA } from './actions';

// initial state
export const initialState: AuthProps = {
  isLoggedIn: false,
  isInitialized: false,
  userId: null,
  user: null,
  userRole: null,
  isBot: false,
  token: null,
  requires2FA: false,
  permissions: [],
};

// ==============================|| AUTH REDUCER ||============================== //

const auth = (state = initialState, action: AuthActionProps) => {
  switch (action.type) {
    case REGISTER:
    case LOGIN:
    case REQUIRES_2FA:
      return {
        ...state,
        ...action.payload,
      };
    case LOGOUT:
      return {
        ...initialState,
        isInitialized: true,
        userRole: null, // Explicitly set userRole to null on logout
      };
    case INITIALIZED:
      return {
        ...state,
        isInitialized: true,
      };
    default:
      return state;
  }
};

export default auth;
